var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3259 10L15.0369 6.28907C15.213 6.11326 15.3121 5.87469 15.3123 5.62584C15.3125 5.37699 15.2139 5.13824 15.0381 4.96212C14.8622 4.786 14.6237 4.68693 14.3748 4.68671C14.126 4.68649 13.8872 4.78514 13.7111 4.96095L10.0002 8.67188L6.28922 4.96095C6.1131 4.78483 5.87423 4.68588 5.62516 4.68588C5.37609 4.68588 5.13722 4.78483 4.9611 4.96095C4.78498 5.13707 4.68604 5.37594 4.68604 5.62501C4.68604 5.87408 4.78498 6.11295 4.9611 6.28907L8.67204 10L4.9611 13.7109C4.78498 13.8871 4.68604 14.1259 4.68604 14.375C4.68604 14.6241 4.78498 14.863 4.9611 15.0391C5.13722 15.2152 5.37609 15.3141 5.62516 15.3141C5.87423 15.3141 6.1131 15.2152 6.28922 15.0391L10.0002 11.3281L13.7111 15.0391C13.8872 15.2152 14.1261 15.3141 14.3752 15.3141C14.6242 15.3141 14.8631 15.2152 15.0392 15.0391C15.2153 14.863 15.3143 14.6241 15.3143 14.375C15.3143 14.1259 15.2153 13.8871 15.0392 13.7109L11.3259 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhiteIcon);
export default __webpack_public_path__ + "static/media/x-white-icon.70c56f8df13445d164b279f7791933be.svg";
export { ForwardRef as ReactComponent };